import { CILINDRAJE_MINIMO_ALTO } from '../Models/coberturaOpcional';

/**
 * Cilindraje de la moto en cc.
 *
 * El RUNT lo entrega como numero, pero al pasar por el lead, por la cotizacion
 * o por una retoma puede llegar como texto ("250", "1.000 c.c.").
 * Ante un valor ausente o ilegible devuelve 0, de modo que la moto se trate
 * como de bajo cilindraje en vez de ofrecer de mas.
 */
export function obtenerCilindraje(valor: unknown): number {
  if (valor === null || valor === undefined || valor === '') {
    return 0;
  }

  if (typeof valor === 'number') {
    return Number.isFinite(valor) ? valor : 0;
  }

  const texto = String(valor).trim();
  const directo = Number(texto);
  if (!Number.isNaN(directo)) {
    return directo;
  }

  const soloDigitos = Number.parseInt(texto.replace(/\D/g, ''), 10);
  return Number.isNaN(soloDigitos) ? 0 : soloDigitos;
}

/** La moto supera el cilindraje minimo para considerarse de alto cilindraje. */
export function esAltoCilindraje(valor: unknown): boolean {
  return obtenerCilindraje(valor) > CILINDRAJE_MINIMO_ALTO;
}
